import React, { useState, useEffect } from "react";
import { Card } from "reactstrap";
import RecoveryPasswordForm from "./form/recoveryPasswordForm";
import { Location, History } from "history";
import { connect } from "react-redux";
import userService from "../../../services/userService";
import { routes } from "../../routes";
interface IProps {
	location: Location;
	history: History;
	verifyEmailWithFirebase: (code: string) => Promise<any>;
}

const RecoveryPassword: React.FC<IProps> = ({ ...props }) => {
	const [valid, setValid] = useState(false);
	const [isVerifyingEmail, setIsVerifyingEmail] = useState(false);
	const [emailVerified, setEmailVerified] = useState(false);

	useEffect(() => {
		const query = new URLSearchParams(props.location.search);
		const mode = query.get("mode");
		const oobCode = query.get("oobCode");

		if (mode === "verifyEmail" && oobCode) {
			setIsVerifyingEmail(true);
			props
				.verifyEmailWithFirebase(oobCode)
				.then(() => {
					setEmailVerified(true);
					setValid(true);
					setTimeout(() => {
						props.history.push(routes.LOGIN);
					}, 2000);
				})
				.catch(() => {
					setIsVerifyingEmail(false);
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.location.search]);

	const handleValidateForm = (validForm: boolean) => {
		setValid(validForm);
	};

	const query = new URLSearchParams(props.location.search);
	const mode = query.get("mode");

	// If verifying email, show loading or success state
	if (mode === "verifyEmail") {
		return (
			<Card className="recovery-password">
				<div className="recovery-password-icon">
					{emailVerified ? (
						<svg
							width="44"
							height="44"
							viewBox="0 0 44 44"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M40.3333 20.3133V22C40.3311 25.9534 39.0509 29.8002 36.6838 32.9667C34.3166 36.1331 30.9893 38.4495 27.1981 39.5705C23.4069 40.6914 19.355 40.5568 15.6465 39.1867C11.9381 37.8167 8.77186 35.2845 6.62008 31.968C4.46831 28.6514 3.44627 24.7281 3.7064 20.7832C3.96652 16.8384 5.49487 13.0833 8.0635 10.078C10.6321 7.07267 14.1034 4.9782 17.9597 4.10694C21.8159 3.23567 25.8505 3.63429 29.4617 5.24333"
								stroke="#1DD6AE"
								strokeWidth="3.66667"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M40.3333 7.33333L22 25.685L16.5 20.185"
								stroke="#1DD6AE"
								strokeWidth="3.66667"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					) : (
						<svg
							width="44"
							height="44"
							viewBox="0 0 44 44"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_1304_8390)">
								<path
									d="M22 40.3334C32.1252 40.3334 40.3333 32.1253 40.3333 22.0001C40.3333 11.8749 32.1252 3.66675 22 3.66675C11.8747 3.66675 3.66663 11.8749 3.66663 22.0001C3.66663 32.1253 11.8747 40.3334 22 40.3334Z"
									stroke="#767676"
									strokeWidth="3.67"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M22 14.6667V22.0001"
									stroke="#767676"
									strokeWidth="3.67"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M22 29.3333H22.0183"
									stroke="#767676"
									strokeWidth="3.67"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</g>
							<defs>
								<clipPath id="clip0_1304_8390">
									<rect width="44" height="44" fill="white" />
								</clipPath>
							</defs>
						</svg>
					)}
				</div>
				<div className="recovery-password-form">
					{emailVerified ? (
						<div style={{ textAlign: "center", padding: "20px" }}>
							<p style={{ marginBottom: "10px" }}>Email verified successfully!</p>
							<p style={{ fontSize: "14px", color: "#767676" }}>Redirecting to login...</p>
						</div>
					) : (
						<div style={{ textAlign: "center", padding: "20px" }}>
							<p>Verifying your email...</p>
						</div>
					)}
				</div>
			</Card>
		);
	}

	// Default password reset flow
	return (
		<Card className="recovery-password">
			<div className="recovery-password-icon">
				{!valid ? (
					<svg
						width="44"
						height="44"
						viewBox="0 0 44 44"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clipPath="url(#clip0_1304_8390)">
							<path
								d="M22 40.3334C32.1252 40.3334 40.3333 32.1253 40.3333 22.0001C40.3333 11.8749 32.1252 3.66675 22 3.66675C11.8747 3.66675 3.66663 11.8749 3.66663 22.0001C3.66663 32.1253 11.8747 40.3334 22 40.3334Z"
								stroke="#767676"
								strokeWidth="3.67"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M22 14.6667V22.0001"
								stroke="#767676"
								strokeWidth="3.67"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M22 29.3333H22.0183"
								stroke="#767676"
								strokeWidth="3.67"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</g>
						<defs>
							<clipPath id="clip0_1304_8390">
								<rect width="44" height="44" fill="white" />
							</clipPath>
						</defs>
					</svg>
				) : (
					<svg
						width="44"
						height="44"
						viewBox="0 0 44 44"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M40.3333 20.3133V22C40.3311 25.9534 39.0509 29.8002 36.6838 32.9667C34.3166 36.1331 30.9893 38.4495 27.1981 39.5705C23.4069 40.6914 19.355 40.5568 15.6465 39.1867C11.9381 37.8167 8.77186 35.2845 6.62008 31.968C4.46831 28.6514 3.44627 24.7281 3.7064 20.7832C3.96652 16.8384 5.49487 13.0833 8.0635 10.078C10.6321 7.07267 14.1034 4.9782 17.9597 4.10694C21.8159 3.23567 25.8505 3.63429 29.4617 5.24333"
							stroke="#1DD6AE"
							strokeWidth="3.66667"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M40.3333 7.33333L22 25.685L16.5 20.185"
							stroke="#1DD6AE"
							strokeWidth="3.66667"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				)}
			</div>
			<div className="recovery-password-form">
				<RecoveryPasswordForm {...props} onValidateForm={handleValidateForm} />
			</div>
		</Card>
	);
};

const mapDispatchToProps = (dispatch: any) => ({
	verifyEmailWithFirebase: (code: string) => dispatch(userService.verifyEmailWithFirebase(code))
});

export default connect(null, mapDispatchToProps)(RecoveryPassword);
